"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./vocabularyDefinition.css');const e="_vocab_15vwz_1",o={vocab:e};exports.default=o;exports.vocab=e;
//# sourceMappingURL=vocabularyDefinition.module.css.cjs.map
